module.exports = __webpack_public_path__ + "static/media/Valley-Wood.5922e8f4.pdf";